import { Link } from 'react-router-dom'
import MediaImage from './MediaImage'
import { revealDelay } from '../lib/reveal'
import { homeCategory, type Story } from '../data/content'
import { storyPath } from '../lib/paths'

type Props = {
  story: Story
  stagger?: number
  compact?: boolean
}

export default function StoryCard({ story, compact = false, stagger = 0 }: Props) {
  const isLook = homeCategory(story) === 'Look Books'

  return (
    <Link
      to={storyPath(story.slug)}
      data-reveal
      style={stagger ? revealDelay((stagger % 4) * 0.08) : undefined}
      className="group flex h-full flex-col"
    >
      <div className={`overflow-hidden ${compact ? 'aspect-[4/5]' : 'aspect-[3/4]'} ${isLook ? 'bg-white' : 'bg-sand'}`}>
        <MediaImage
          src={story.image}
          size="card"
          alt={story.imageAlt || story.title}
          className={`h-full w-full ${isLook ? 'object-contain object-center' : 'object-cover object-top'}`}
        />
      </div>
      <p className={`text-caps text-rose ${compact ? 'mt-2' : 'mt-3'}`}>{homeCategory(story)}</p>
      <h3
        className={`${
          compact
            ? 'text-[clamp(14px,1.2vw,16px)] font-medium tracking-[0.02em] uppercase leading-snug'
            : 'text-caps-h3'
        } mt-1.5 text-ink group-hover:text-rose`}
      >
        {story.title}
      </h3>
      <p className="mt-1 line-clamp-2 text-muted">{story.dek}</p>
    </Link>
  )
}
